import React, { memo } from "react"
import { Flex, Text } from "@chakra-ui/react"
import { Icon } from "@app/components/Icon"
import { IReview } from "@app/components/Product/Review/ReviewTypes"

type Props = {
  review: IReview
}

export const ReviewCard: React.FC<Props> = memo(({ review }) => {
  const stars = Array.from({ length: 5 }, (_, index) => {
    return <Icon key={index} name={review.score >= index + 0.5 ? "review-star-full" : "review-star-empty"} width={5} height={5} />
  })
  return (
    <Flex gap={2} flexDirection={{ base: "column", sm: "row" }}>
      <Flex gap={2} alignItems={"start"} paddingRight={2} flexDirection="column" minWidth={"80"}>
        <Flex gap="1" alignItems={"start"} flexDirection={"row"}>
          {stars}
        </Flex>
        <Text size="h2" fontWeight={500} color="grey.text" lineHeight={1}>
          {review?.author}
        </Text>
        <Text size="h2" color="grey.text">
          {review?.displayDate}
        </Text>
      </Flex>
      <Flex gap={2} alignItems={"start"} paddingRight={2} flexDirection="column">
        <Text size="md" as={"h2"} fontWeight={500} color="grey.text" lineHeight={1}>
          {review?.contentTitle}
        </Text>
        <Text lineHeight={1.4}>{review?.contentMessage}</Text>
      </Flex>
    </Flex>
  )
})
